import HEROIMG from "../../assets/birth_hero_img.png";

import BIRTH_STAT_1 from "../../assets/birth_stat_1.png"
import BIRTH_STAT_2 from "../../assets/birth_stat_2.png"

import LANG from "../../assets/Vector.png"
import PEN from "../../assets/Group 71.png"
import MEDAL from "../../assets/Medal - Iconly Pro.png"

import WHEELBAG from "../../assets/wheel bag - Iconly Pro.png"
import GRADUATED from "../../assets/Graduated - Iconly Pro.png"
import EGG from "../../assets/Egg - Iconly Pro.png"
import FACESCAN from "../../assets/Face Scan - Iconly Pro.png"

import FLAG_1 from "../../assets/flag-1.png"
import FLAG_2 from "../../assets/flag-2.png"
import FLAG_3 from "../../assets/flag-3.png"

import ASSESSMENT_1 from "../../assets/birth-asesment-1.png"
import ASSESSMENT_2 from "../../assets/birth-asesment-2.png"
import ASSESSMENT_3 from "../../assets/birth-asesment-3.png"
import ASSESSMENT_4 from "../../assets/birth-asesment-4.png"
import ASSESSMENT_5 from "../../assets/birth-asesment-5.png"
import ASSESSMENT_6 from "../../assets/birth-asesment-6.png"

import REDPEN from "../../assets/pen_red.png"
import CIRCLESTICKER from "../../assets/Circle Sticker - Iconly Pro.png"
import TICKETTICK from "../../assets/Ticket tick - Iconly Pro.png"

import INFORMATION from "../../assets/information - Iconly Pro.png"
import LANG_GREEN from "../../assets/translate_green.png"
import MESSAGEWORD from "../../assets/messages word - Iconly Pro.png"
import ARROWUP from "../../assets/arrow_up.png"

import CHECKSQUARE from "../../assets/Tick Square - Iconly Pro.png"

import BIRTHSECTION11IMG from "../../assets/birth-section11-Img.png"

export const IMAGES = {
    HEROIMG,
    BIRTH_STAT_1,
    BIRTH_STAT_2,
    LANG,
    PEN,
    MEDAL,
    EGG,
    FACESCAN,
    GRADUATED,
    WHEELBAG,
    FLAG_1,
    FLAG_2,
    FLAG_3,
    ASSESSMENT_1,
    ASSESSMENT_2,
    ASSESSMENT_3,
    ASSESSMENT_4,
    ASSESSMENT_5,
    ASSESSMENT_6,
    REDPEN,
    CIRCLESTICKER,
    TICKETTICK,
    INFORMATION,
    LANG_GREEN,
    MESSAGEWORD,
    ARROWUP,
    CHECKSQUARE,
    BIRTHSECTION11IMG
};